import domtoimage from 'dom-to-image'
import moment from 'moment-timezone'
import { useEffect, useState } from 'react'

import { useGetUnitGenericDetails } from '@apps-common/apis/portal/unit/get-unit-generic-details'
import { ButtonRoundSm } from '@apps-common/components/elements'
import { ModalCloseButton, ModalContainer } from '@apps-common/components/modals/modal'
import { QRCodeGenerator } from '@apps-common/components/qr-code/QRCodeGenerator'
import { commonIcons } from '@apps-common/config/icons'
import { ModalDismiss } from '@apps-common/config/modal'

export const QrCodePortalUnitModal = ({
  onDismiss,
  componentProps
}: {
  onDismiss: (data?: string | null | undefined | number, role?: string) => void
  componentProps: { unitId: string }
}) => {
  const { unitId } = componentProps
  const [qrData, setQrData] = useState<string>()

  const { data, isLoading, isError } = useGetUnitGenericDetails({ config: { enabled: !!unitId }, unitId })

  useEffect(() => {
    setQrData(`https://portal.radionetportal.com/qr-code?unitId=${data?.unitId}`)
  }, [data])

  const downloadURI = (uri: string, name: string) => {
    const link = document.createElement('a')

    link.download = name
    link.href = uri
    document.body.appendChild(link)
    link.click()
  }

  const downloadAsImage = () => {
    const node = document.getElementById('portal-unit-qr-code')

    if (!node) return

    domtoimage.toJpeg(node, { quality: 1 }).then((dataUrl) => {
      downloadURI(dataUrl, `qr_code_${data?.product}_${data?.accountNo}_${moment().format('DD.MM.YY.hh.mm')}.png`.toLowerCase())
    })
  }

  const loading = isLoading || isError

  return (
    <ModalContainer
      innerClasses='absolute border-none bg-transparent !min-h-[220px] sm:!min-w-[50px] sm:!w-auto !overflow-y-auto !flex items-center justify-center'
      containerClasses='!h-auto flex items-center justify-center'
      onDismiss={onDismiss}
    >
      <div className='flex flex-col gap-[10px] pt-2'>
        <div className='flex items-center justify-between gap-[10px] px-[10px]'>
          <ModalCloseButton closeModal={() => onDismiss(null, ModalDismiss.Cancel)} />
          <ButtonRoundSm
            type='button'
            className='action-brand'
            callback={() => {
              downloadAsImage()
            }}
            tooltip={{ id: `portal-unit-qr-code-download-${unitId}`, message: 'Download' }}
          >
            <commonIcons.download />
          </ButtonRoundSm>
        </div>
        <div className='bg-white rounded-3xl border border-border p-4 overflow-hidden'>
          <div id='portal-unit-qr-code' className='inline-block'>
            <div className='bg-white p-[10px]'>
              <div className='text-[#2D2D30] h-[300px] overflow-hidden relative flex items-center justify-between'>
                {qrData && <QRCodeGenerator data={qrData} fgColor='#2D2D30' bgColor='#FFFFFF' />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  )
}
